<template>
  <v-switch
    :id="id"
    :key="id"
    v-model="model"
    class="ag-switch"
    density="compact"
    hide-details
    inset
    :disabled="disabled"
    :false-value="falseValue"
    :true-value="trueValue"
    :is-active="model === trueValue"
  >
    <template #label>
      <span :id="id + '_label'" class="ag-switch__label" :data-qa="labelDataQa"> {{ label }} </span>
      <span v-if="caption" :id="id + '_caption'" class="ag-switch__caption" :data-qa="captionDataQa">
        {{ caption }}
      </span>
    </template>
  </v-switch>
</template>

<script>
import { uniqueId } from 'lodash';

export default {
  emits: ['update:modelValue', 'change'],
  props: {
    id: {
      type: String,
      default: () => uniqueId('ag-switch'),
    },

    label: {
      type: String,
      required: false,
    },

    labelDataQa: {
      type: String,
      default: undefined,
    },

    captionDataQa: {
      type: String,
      default: undefined,
    },

    caption: {
      type: String,
      default: '',
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    modelValue: {
      type: [String, Number, Boolean, Object, Array],
      default: true,
    },

    trueValue: {
      type: [String, Number, Boolean, Object, Array],
      default: true,
    },

    falseValue: {
      type: [String, Number, Boolean, Object, Array],
      default: false,
    },
  },

  computed: {
    model: {
      get() {
        return this.modelValue;
      },

      set(value) {
        this.$emit('change', value);
        this.$emit('update:modelValue', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.ag-switch ::v-deep(.v-label) {
  display: flex;
  justify-content: center;
  opacity: 1;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.ag-switch__label {
  color: $neutral-color-high-dark;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 133%; /* 18.62px */
  letter-spacing: 0.14px;
}

.ag-switch__caption {
  color: $neutral-color-high-medium;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 133%; /* 18.62px */
  letter-spacing: 0.14px;
}
</style>
